export const fingerprintingFlag = true
export const bluetoothPairingFlag = true
export const essentialOnlyButtonsFlag = true
export const voiceColumnFlag = false
